<template>
    <section class="bg-[#725a86] text-white py-16 px-4">
      <div class="text-center mb-12">
        <h2 class="text-3xl font-semibold">Redundância e Segurança</h2>
        <p class="text-sm mt-1">Saiba mais ...</p>
      </div>
  
      <div class="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
        <div
          v-for="(item, index) in seguranca"
          :key="index"
          class="bg-white text-gray-800 rounded-xl shadow p-20 flex gap-4"
        >
          <component :is="item.icone" class="w-20 h-20 text-[#725a86] shrink-0 mt-1" />
          <div>
            <h3 class="font-bold text-lg text-[#222] mb-6">{{ item.titulo }}</h3>
            <p class="text-sm text-gray-600 mb-3">{{ item.descricao }}</p>
            <ul class="text-sm space-y-1 text-gray-700">
              <li v-for="(sub, i) in item.lista" :key="i">✔ {{ sub }}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  import {
    Zap,
    Network,
    ShieldCheck,
    Fan
  } from 'lucide-vue-next'
  
  const seguranca = [
    {
      titulo: 'Power',
      descricao: 'Sistema Ininterrupto de Energia Elétrica',
      icone: Zap,
      lista: [
        'Sistema Ininterrupto de Energia UPS',
        'Geradores próprios a diesel',
        'Nobreaks redundante'
      ]
    },
    {
      titulo: 'Networking',
      descricao: 'Link de alto disponibilidade com rede dupla',
      icone: Network,
      lista: [
        'Link de acesso duplo de 50Gbps.',
        'Rede interna de 600Gbps.',
        'Roteadores IBM.'
      ]
    },
    {
      titulo: 'Segurança',
      descricao: 'Seguimos os padrões de segurança internacionais e proteção de informação',
      icone: ShieldCheck,
      lista: [
        'Sistema anti DDoS.',
        'Ambiente monitorado e acesso restrito.',
        'Firewall de ponta.'
      ]
    },
    {
      titulo: 'Climatização',
      descricao: 'Sistema de resfriamento por água com tecnologia própria',
      icone: Fan,
      lista: [
        'Condicionado Self Contained',
        'Condensação a ar remoto',
        'Resfriamento com sistema de água'
      ]
    }
  ]
  </script>
  
  <style scoped>
  ul li::marker {
    color: #725a86;
  }
  </style>
  